import { DtacBase } from "./dtac-base";

export interface SecurityDeclaration extends DtacBase {
  securityStatus: string;
};

export const SECURITY_DECLARATION_TEMPLATE: SecurityDeclaration = {
  '@id': '',
  '@type': '',
  securityStatus: ''
};
